import { render, staticRenderFns } from "./NosePrizeTable.vue?vue&type=template&id=c4c672f2&scoped=true&"
import script from "./NosePrizeTable.vue?vue&type=script&lang=js&"
export * from "./NosePrizeTable.vue?vue&type=script&lang=js&"
import style0 from "./NosePrizeTable.vue?vue&type=style&index=0&id=c4c672f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c672f2",
  null
  
)

export default component.exports